export default "__VITE_ASSET__SRbFdOZY__"